<div class="dashboard-container px-4">
  <div class="content">
    <div class="services">
      <h3 class="content-header" translate>Book Services</h3>

      <div class="row">
        <div class="col">
          <div
            class="service-card col col-sm-6 col-lg-5 col-xl-4"
            (click)="createBooking()"
            appTrackClick="dashboard-book-service-btn"
          >
            <img src="/assets/services/d2a-symbol.svg" alt="D2A" />
            <h4 translate>Book a service</h4>
            <p translate>Door-Check-in-Service-Breakdown</p>
          </div>
        </div>
      </div>
    </div>
    @if (bookings?.length) {
      <div class="bookings">
        <h3 class="content-header">
          <span translate>Active bookings</span>
          <button
            mat-button
            color="primary"
            class="link view-all-btn"
            (click)="goToBookings()"
            appTrackClick="dashboard-view-all-bookings-btn"
          >
            <span class="btn-content">
              <span translate>View All</span>
              @if (dir !== 'rtl') {
                <mat-icon class="arrow-icon">arrow_right_alt</mat-icon>
              }
              @if (dir === 'rtl') {
                <mat-icon class="arrow-icon">keyboard_backspace</mat-icon>
              }
            </span>
          </button>
        </h3>
        <div class="horizontal-scroll">
          <div class="cards-container">
            @for (booking of bookings; track booking) {
              <div class="booking-card" (click)="goToBooking(booking.id)">
                <div class="row g-0">
                  <div class="col-3">
                    <div
                      class="booking-img booking-type-{{
                        booking.bookingTypeId
                      }}"
                    >
                      <img
                        [src]="getBookingSymbol(booking.bookingTypeId)"
                        alt="booking.bookingTypeId"
                        class="booking-symbol"
                      />
                    </div>
                  </div>
                  <div class="col-9 px-3">
                    <p class="type-p">
                      {{
                        getBookingTypeLabel(booking.bookingTypeId) | translate
                      }}
                    </p>
                    <p class="ref-p">
                      <span translate>ID:</span>
                      {{ booking.id | numberTranslate }}
                    </p>
                    <div class="card-head">
                      <app-status-badge
                        [type]="booking?.styleGroup"
                        [label]="booking?.stageTitle"
                      ></app-status-badge>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <div class="text-center">
      <app-loader [isLoading]="bookingsLoader"></app-loader>
    </div>
  </div>
  @if (showAnalytics && has5bookings) {
    <div class="row justify-content-between min-h-50 mx-0 mt-5 mt-sm-2 mt-md-0">
      <div class="col-12 min-h-100 px-2 comparative-chart-container mb-3">
        <div class="d-flex flex-wrap justify-content-between mt-4 mb-n3">
          <span class="fs-16 fw-500 mt-2" translate>Analytics</span>
          <form
            [formGroup]="comparativeTypeFiltersForm"
            class="d-flex flex-wrap align-self-end justify-content-end"
          >
            <mat-form-field class="px-1 flex-grow-1" appearance="outline">
              <mat-select
                [placeholder]="'Booking Type' | translate"
                formControlName="bookingTypeId"
              >
                @for (service of services; track service) {
                  <mat-option [value]="service.id">
                    {{ service.title }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </form>
        </div>
        <div class="chart-responsive-wrapper">
          <canvas
            baseChart
            [data]="barChartData"
            [options]="barChartOptions"
            [type]="barChartType"
            [plugins]="barChartPlugins"
          ></canvas>
        </div>
      </div>
    </div>
  }
</div>
